export const EVENT_ACTION = {
  SLIDER_PLAY: 'live_casino_play_slider_game',
  SLIDER_REDIRECT: 'live_casino_more_slider_banner',
  FULLSCREEN: 'live_casino_fullscreen',
  PLAY_REAL_GAME: 'live_casino_play_real_game',
  FILTER_PLAY: 'live_casino_play_category_game',
  FILTER_CATEGORY: 'live_casino_filter_category_game',
  FILTER_CATEGORIES_ALL: 'live_casino_filter_categories',
  FILTER_PROVIDER: 'live_casino_filter_provider_game',
  FILTER_PROVIDERS_ALL: 'live_casino_filter_providers',
  SEARCH_PLAY: 'live_casino_search_play_game',
  SEARCH_MOBILE_NAV_ICON: 'live_casino_search_open',
  WIDGET_PLAY: 'live_casino_main_category_game_play',
  GAME_PREVIEW_PAGE_REAL: 'live_casino_preview_game_play',
  GAME_PREVIEW_PAGE_DEMO: 'live_casino_preview_game_play_demo',
  CATEGORY_WIDGET_ALL_GAMES: 'live_casino_main_category_all_games',
  MAIN_BALANCE: 'live_casino_main_balance',
  PROVIDER_DETAIL: 'live_casino_play_provider_game',
  CROSS_SALE_WIDGET_ALL_GAMES: 'live_casino_cross_sale_widget_all_games',
  CROSS_SALE_WIDGET_PLAY: 'live_casino_cross_sale_widget_play_game',

  // nav
  NAVIGATION_PRODUCT_TYPE: 'casino_hall_product_type_navigation',
  NAV_LOBBY: 'live_casino_nav_lobby',
  NAV_BONUSES: 'live_casino_nav_bonuses',
  NAV_HOW_TO_PLAY: 'live_casino_nav_how_to_play',
  NAV_PROMO: 'live_casino_nav_promo',
  NAV_SEARCH: 'live_casino_nav_search',
  NAV_HALL_OF_FAME: 'live_casino_nav_hall_of_fame',
  NAV_COLLECTING_GAMES: 'live_casino_nav_collecting_games',
  NAV_WAGERING_GAMES: 'live_casino_nav_wagering_games',
  NAV_RECENT_GAMES: 'live_casino_nav_recent_games',

  MOBILE_NAV_SEARCH: 'slots_search_mobile',
  CASINO_NAVIGATION_CLICK: 'casino_navigation_click',

  // promo
  PROMO_TILE: 'live_casino_promo_tile',
  PROMO_OPEN_RULES: 'live_casino_promo_open_rules',
  PROMO_CLOSE_RULES: 'live_casino_promo_close_rules',

  // bonuses
  BONUS_RULES_OPEN: 'live_casino_bonus_rules_open',
  BONUS_RULES_CLOSE: 'live_casino_bonus_rules_close',
  BONUS_TAKE_PART: 'live_casino_bonus_take_part',
  BONUS_CANCEL: 'live_casino_bonus_cancel',
  BONUS_DEPOSIT: 'live_casino_bonus_deposit',
  BONUS_CANCEL_CONFIRM: 'live_casino_bonus_cancel_confirm',
  BONUS_TO_GAME: 'live_casino_bonus_to_game',
  BONUS_PICK_UP: 'live_casino_bonus_pick_up',
  BONUS_SUCCESSFUL: 'live_casino_bonus_successful',
  BONUS_ALL: 'live_casino_bonus_all',
  BONUS_WIN_BACK: 'live_casino_bonus_win_back',
  BONUS_TILE: 'live_casino_bonus_tile',
  WAGERING_BONUS_PAGE_SELECT_WAGERING: 'live_casino_wagering',
  WAGERING_BONUS_PAGE_PLAY: 'live_casino_wagering_game_play',
  BONUS_TILE_HISTORY: 'live_casino_bonus_tile_history',
  BONUS_NAV_CURRENT: 'live_casino_bonus_nav_current',
  BONUS_NAV_HISTORY: 'live_casino_bonus_nav_history',
  BONUS_LOGIN: 'live_casino_bonus_login',
  BONUS_AVAILABLE: 'live_casino_bonus_actual',

  // hall of fame
  HALL_OF_FAME_CURRENT: 'hall_of_fame_current',
  HALL_OF_FAME_PREVIOUS: 'hall_of_fame_previous',
  HALL_OF_FAME_PLAY_CURRENT_PLAY: 'hall_of_fame_current_play_game',
  HALL_OF_FAME_PLAY_PREVIOUS_PLAY: 'hall_of_fame_previous_play_game',
  HALL_OF_FAME_WINNER_WIDGET: 'hall_of_fame_winner',
  HALL_OF_FAME_WINNER_CHECK: 'hall_of_fame_winner_check',
  HALL_OF_FAME_EMPTY_STATE: 'hall_of_fame_empty',
  HALL_OF_FAME_MONTH_SELECT: 'hall_of_fame_months_select', // will be used later

  // categories widget
  CATEGORIES_WIDGET_ALL: 'live_casino_categories',
  CATEGORIES_WIDGET_CATEGORY: 'live_casino_category',

  // big wins
  BIG_WIN_CATEGORY_PLAY: 'live_casino_win_card_category',
  BIG_WIN_MEGA_CATEGORY_PLAY: 'live_casino_bigwin_card_category',
  BIG_WIN_WIDGET_PLAY: 'live_casino_win_card_widget',
  BIG_WIN_MEGA_WIDGET_PLAY: 'live_casino_bigwin_card_widget',

  // providers widget
  PROVIDERS_WIDGET_ALL: 'live_casino_providers',
  PROVIDERS_WIDGET_PROVIDER: 'live_casino_provider',
  PROVIDER_SORT: 'live_casino_provider_sort',
  PROVIDER_SORT_APPLY: 'live_casino_provider_sort_apply',

  // Similar
  GAME_PAGE_OTHER_GAMES: 'live_casino_other_games',
  GAME_PAGE_OTHER_GAMES_PLAY: 'live_casino_other_games_play',
  GAME_PAGE_SIMILAR_GAMES: 'live_casino_similar',
  GAME_PAGE_SIMILAR_GAMES_PLAY: 'live_casino_similar_play',
};

export const DATA_LAYER_EVENT = 'live_casino';
export const DATA_LAYER_EVENT_CATEGORY = 'live_casino';
